import { View, StyleSheet } from "react-native";
import { ThemedText } from "@/components/ThemedText";
import { useTheme } from "@/hooks/useTheme";
import { MaterialCommunityIcons } from "@expo/vector-icons";

export default function Learning() {
  const { colors } = useTheme();

  return (
    <View style={[styles.container, { backgroundColor: colors.background }]}>
      <MaterialCommunityIcons name="school-outline" size={64} color={colors.placeholder} />
      <ThemedText style={styles.title}>No Courses Assigned</ThemedText>
      <ThemedText style={[styles.subtitle, { color: colors.textSecondary }]}>
        Your training and learning materials will appear here
      </ThemedText>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 24,
    gap: 8,
  },
  title: {
    fontSize: 18,
    fontWeight: "600",
    marginTop: 8,
  },
  subtitle: {
    fontSize: 14,
    textAlign: "center",
  },
});
